// extracted by mini-css-extract-plugin
export var hideEditor = "_l0-2";
export var infoIcon = "_l0-3";
export var label = "_l0-1";
export var labelContainer = "_l0-0";
export var readonlyText = "_l0-4";